export default "__VITE_ASSET__DKmJZkf9__"